export default __webpack_public_path__ + "resources/icons/d500-c0e9.png";